import * as React from "react";

function SvgVideocamWhite48Dp(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 16"
      {...props}
    >
      <path
        d="M18.667 6V1.333A1.337 1.337 0 0017.333 0h-16A1.337 1.337 0 000 1.333v13.334A1.337 1.337 0 001.333 16h16a1.337 1.337 0 001.333-1.333V10l3.053 3.053A1.337 1.337 0 0024 12.107V3.88a1.337 1.337 0 00-2.28-.947z"
        fill="#0a2463"
      />
    </svg>
  );
}

export default SvgVideocamWhite48Dp;
